export class Evaluation {
    constructor(mode = 'default') {
        this.mode = mode;
    }

    highlight_missing_required(){
        this.form.find(".missing_required").removeClass("missing_required");

        let form_index = this.form.data('form_index');
        let evalData = this.data.evaluations[form_index];
        let groups = evalData.groups;
        let missing_required = false;

        Object.entries(groups).forEach(entry => {
            let group = entry[1];
            let questions = evalData.questions.filter(item => item.group_id == group.id);
            let filled_out_questions = 0;

            Object.entries(questions).forEach(entry => {
                let question = entry[1];
                let question_dom = this.dom.find(`[name=${question.id}]`);

                let trimmedValue = question_dom.val()?.trim();
                if(question_dom.is(':checked')
                    || (typeof trimmedValue !== 'undefined' && trimmedValue !== '')
                    || question_dom.not(':visible').length) {
                    filled_out_questions++;
                }
            })

            let passed = group.min_required_answers <= filled_out_questions;
            if(!passed) {
                Object.entries(questions).forEach(entry => {
                    let question = entry[1];
                    this.dom.find(`[name=${question.id}]`).addClass("missing_required");
                });
            }
        })

        this.form.find(".question_container_range").each(
            (i,v) => {
                let rangeContainer = $(this.form).find(".question_container_range")[i];
                if ($(rangeContainer).find("input[type=radio]:checked").length == 0 &&
                    $(rangeContainer).hasClass("is_mandatory") &&
                    $(rangeContainer).is(":visible")){
                    $(rangeContainer).addClass("missing_required");
                    missing_required = true;
                }
            }
        );

        this.form.find(".question_container_choice").each(
            (i,v) => {
                let choiceContainer = $(this.form).find(".question_container_choice")[i];
                if ($(choiceContainer).find("input[type=radio]:checked, input[type=checkbox]:checked").length == 0 &&
                    $(choiceContainer).find("textarea").length == 0 &&
                    $(choiceContainer).hasClass("is_mandatory") &&
                    $(choiceContainer).is(":visible"))
                {
                    $(choiceContainer).addClass("missing_required");
                    missing_required = true;
                }
            }
        );

        this.form.find(".qt_Open").each(
            (i,v) => {
                let choiceContainer = this.form.find(".qt_Open")[i];

                if (!$(choiceContainer).find("textarea").val().trim() &&
                    $(choiceContainer).find('.question_other_container').hasClass("is_mandatory") &&
                    $(choiceContainer).is(":visible")) {
                    $(choiceContainer).find('.question_other_container').addClass("missing_required");
                    missing_required = true;
                }

                if (!$(choiceContainer).find("textarea").val().trim() &&
                    $(choiceContainer).hasClass("is_mandatory") &&
                    $(choiceContainer).is(":visible")) {
                    $(choiceContainer).addClass("missing_required");
                    missing_required = true;
                }
            }
        );

        this.form.find(".qt_Inputbox_number").each(
            (i) => {
                let numberContainer = this.form.find(".qt_Inputbox_number")[i];
                if (!$(numberContainer).find("input[type=number]").val() &&
                    $(numberContainer).hasClass("is_mandatory") &&
                    $(numberContainer).is(":visible"))
                {
                    $(numberContainer).addClass("missing_required");
                    missing_required = true;
                }
            }
        );

        this.form.find(".qt_Inputbox_positive_number").each(
            (i) => {
                let positiveNumberContainer = this.form.find(".qt_Inputbox_positive_number")[i];
                if (!$(positiveNumberContainer).find("input[type=number]").val() &&
                    $(positiveNumberContainer).hasClass("is_mandatory") &&
                    $(positiveNumberContainer).is(":visible"))
                {
                    $(positiveNumberContainer).addClass("missing_required");
                    missing_required = true;
                }
            }
        );

        return missing_required;
    }

    checkRequired() {
        let completed = true;

        let form_index = this.form.data('form_index');
        let evalData = this.data.evaluations[form_index];
        let groups = evalData.groups;

        Object.entries(groups).forEach(entry => {
            let group = entry[1];
            let questions = evalData.questions.filter(item => item.group_id == group.id);
            let filled_out_questions = 0;

            Object.entries(questions).forEach(entry => {
                let question = entry[1];
                let question_dom = this.dom.find(`[name=${question.id}]`);

                let trimmedValue = question_dom.val()?.trim();
                if(question_dom.is(':checked')
                    || (typeof trimmedValue !== 'undefined' && trimmedValue !== '')
                    || question_dom.not(':visible').length) {
                    filled_out_questions++;
                }
            })

            let passed = group.min_required_answers <= filled_out_questions;
            completed = completed && passed;
        })

        this.form.find(".question_container_range").each(
            (i,v) => {
                let rangeContainer = this.form.find(".question_container_range")[i];
                if ($(rangeContainer).find("input[type=radio]:checked").length == 0 &&
                    $(rangeContainer).hasClass("is_mandatory") &&
                    $(choiceContainer).is(":hidden") == false )
                {
                    completed = false;
                }
            }
        );

        this.form.find(".question_container_choice").each(
            (i,v) => {
                let choiceContainer = this.form.find(".question_container_choice")[i];
                if ($(choiceContainer).find("input[type=radio]:checked").length == 0 &&
                    $(choiceContainer).find("input[type=checkbox]:checked").length == 0 &&
                    $(choiceContainer).find("textarea").length == 0 &&
                    $(choiceContainer).hasClass("is_mandatory") &&
                    $(choiceContainer).is(":hidden") == false )
                {
                    completed = false;
                }
            }
        );

        this.form.find(".qt_Open").each(
            (i,v) => {
                let choiceContainer = $(this.form).find(".qt_Open")[i];

                if (!$(choiceContainer).find("textarea").val() &&
                    ($(choiceContainer).find('.question_other_container').hasClass("is_mandatory") ||
                        $(choiceContainer).hasClass("is_mandatory")) &&
                    $(choiceContainer).is(":hidden") == false )
                {
                    completed = false;
                }
            }
        );

        return completed;
    }

    populate_answers(formDom){
        var answers;
        $.ajax({
            url	: "api/evaluation",
            type: "GET",
            data: formDom.serialize(),
        }).then(answers => {
            for(let i = 0; i < answers.length; i++)
            {
                if (answers[i].na == "1")
                {
                    formDom.find("input[name="+answers[i].question_id+"][value=na]").attr("checked","checked");
                    formDom.find('input[name="'+answers[i].question_id+'[]"][value=na]').attr("checked","checked");

                    formDom.find("input[name="+answers[i].question_id+"][value=na]").closest('.question_container').removeAttr('hidden');
                    formDom.find('input[name="'+answers[i].question_id+'[]"][value=na]').closest('.question_container').removeAttr('hidden');
                }
                else if (answers[i].choice_id > 0)
                {
                    formDom.find("input[name="+answers[i].question_id+"][value="+answers[i].choice_id+"]").attr("checked","checked");
                    formDom.find('input[name="'+answers[i].question_id+'[]"][value='+answers[i].choice_id+"]").attr("checked","checked");

                    formDom.find("input[name="+answers[i].question_id+"_"+answers[i].choice_id+"][value="+answers[i].choice_id+"]").attr("checked","checked");
                    formDom.find('input[name="'+answers[i].question_id+"_"+answers[i].choice_id+'[]"][value="+answers[i].choice_id+"]').attr("checked","checked");

                    formDom.find("input[name="+answers[i].question_id+"][value="+answers[i].choice_id+"]").closest('.question_container').removeAttr('hidden');
                    formDom.find('input[name="'+answers[i].question_id+'[]"][value='+answers[i].choice_id+"]").closest('.question_container').removeAttr('hidden');

                    formDom.find("input[name="+answers[i].question_id+"_"+answers[i].choice_id+"][value="+answers[i].choice_id+"]").closest('.question_container').removeAttr('hidden');
                    formDom.find('input[name="'+answers[i].question_id+"_"+answers[i].choice_id+'[]"][value='+answers[i].choice_id+"]").closest('.question_container').removeAttr('hidden');
                }
                else if (answers[i].value != null)
                {
                    formDom.find("input[name="+answers[i].question_id+"][value="+answers[i].value+"]").attr("checked","checked");
                    formDom.find('input[name="'+answers[i].question_id+'[]"][value='+answers[i].value+"]").attr("checked","checked");

                    formDom.find("input[name="+answers[i].question_id+"][value="+answers[i].value+"]").closest('.question_container').removeAttr('hidden');
                    formDom.find('input[name="'+answers[i].question_id+'[]"][value='+answers[i].value+"]").closest('.question_container').removeAttr('hidden');

                    formDom.find("textarea[name=" + answers[i].question_id + "]").html(answers[i].value);
                    formDom.find('textarea[name="' + answers[i].question_id + '[]"]').html(answers[i].value);

                    formDom.find("textarea[name=" + answers[i].question_id + "]").closest('.question_container').removeAttr('hidden');
                    formDom.find('textarea[name="' + answers[i].question_id + '[]"]').closest('.question_container').removeAttr('hidden');
                }
                else if (answers[i].text != null)
                {
                    formDom.find("textarea[name="+answers[i].question_id+"]").html(answers[i].text);
                    if(answers[i].text != '' ||
                        typeof formDom.find("textarea[name=" + answers[i].question_id + "]").closest('.question_container').data('dependencies') == 'undefined' ||
                        formDom.find("textarea[name=" + answers[i].question_id + "]").closest('.question_container').data('dependencies').length == 0) {
                        formDom.find("textarea[name=" + answers[i].question_id + "]").closest('.question_container').removeAttr('hidden');
                    }
                }
                else if (answers[i].file_id != null) {
                    formDom.find("input[id="+answers[i].question_id+"_"+answers[i].answer_set_id+"]").parent().append("<label>"+answers[i].display_name+"</label>");
                }
            }

            this.show_hide_dependencies(formDom);
        });
    }

    show_hide_dependencies(tab){
        tab.find('.question_container').each((i, element) => {
            let showQuestion = true;
            if (typeof $(element).data('dependencies') != 'undefined') {
                let dependencies = $(element).data('dependencies');

                if(dependencies && dependencies.length != 0){
                    for (let d = 0; d < dependencies.length; d++) {
                        let dependency = dependencies[d];
                        if (
                            !tab.find('.question_choice input[name=' + dependency.question_id + '][value=' + dependency.choice_id + ']').is(':checked')
                            && !tab.find('.question_choice input[name="' + dependency.question_id + '[]"][value=' + dependency.choice_id + ']').is(':checked')
                        ) {
                            showQuestion = false;
                            break;
                        }
                    }
                }
            }

            if(showQuestion)
            {
                $(element).find('input,select,textarea').closest('.question_container').removeAttr('hidden')
                $(element).show();
            }
            else
            {
                $(element).find('input,select,textarea').each((i,test) => {
                    if($(test).prop('type') == 'textarea'){
                        $(test).val('');
                    } else {
                        $(test).prop('checked', false);
                    }
                })
                $(element).hide();
                $(element).find('input,select,textarea').closest('.question_container').attr('hidden', 'hidden')
            }
        })
    }

    apply_evaluation_html(html, callback, callback_params) {
        let evalDom = $(html);

        evalDom.on('submit', "form[name=evaluation]", (event) => {
            this.submit_evaluation(event, evalDom)
        });
        this.submit_callback = callback;
        this.submit_callback_params = callback_params;

        evalDom.on('change', '.question_choice input', (event) => {
            if($(event.target).is(':checked') || $(event.target).attr('type') == 'checkbox') {
                this.show_hide_dependencies(evalDom);
            }
        })

        evalDom.on('click', '#print_eval', () => this.printEval(evalDom));
        return evalDom;
    }

    printEval(evalDom)
    {
        let w = window.open();
        w.document.write("<style> textarea {width: 500px; height: 45px} </style>")
        w.document.write(evalDom.find("#print_div").html());
        w.print();
        w.close();
    }

    processMode() {
        if(this.mode == 'view') {
            this.dom.find('input, select').attr('disabled', 'disabled');
            this.dom.find('input[type=submit]').hide();
        }
    }
}
